const normalFontSizes = {
  xs: "0.75rem",
  sm: "0.875rem",
  md: "1rem",
  lg: "1.125rem",
  xl: "1.25rem",
  "2xl": "1.5rem",
  "3xl": "1.875rem",
  "4xl": "2.25rem",
  "5xl": "3rem",
  "6xl": "4rem",
  "7xl": "5rem",
  "8xl": "6rem",
  "9xl": "7rem",
};

const bigFontSizes = {
  xs: "0.875rem",
  sm: "1rem",
  md: "1.125rem",
  lg: "1.25rem",
  xl: "1.5rem",
  "2xl": "1.875rem",
  "3xl": "2.25rem",
  "4xl": "3rem",
  "5xl": "4rem",
  "6xl": "5rem",
  "7xl": "6rem",
  "8xl": "7rem",
  "9xl": "8rem",
};

const largeFontSizes = {
  xs: "1rem",
  sm: "1.125rem",
  md: "1.25rem",
  lg: "1.5rem",
  xl: "1.875rem",
  "2xl": "2.25rem",
  "3xl": "3rem",
  "4xl": "4rem",
  "5xl": "5rem",
  "6xl": "6rem",
  "7xl": "7rem",
  "8xl": "8rem",
  "9xl": "9rem",
};

export { bigFontSizes, largeFontSizes, normalFontSizes };
